import React from "react";
import Our from "./Our/Our";
import Holiday from "./Holiday/Holiday";

const Classic = () => {
  return (
    <>
      <Our />
      <Holiday />
    </>
  );
};

export default Classic;
